import Model from "./model";
import ProjectSectionLink from "./ProjectSectionLink";

export interface ProjectSectionData {
    _id: string;
    key?: string;
    name: string;
    type?: string;
    description: string;
    links?: ProjectSectionLink[];
    projects: string[];
    newSection?: ProjectSection | boolean;
}

export default class ProjectSection extends Model {
    _id: string;
    key: string;
    name: string;
    type?: string;
    description: string;
    links?: ProjectSectionLink[];
    projects: string[];
    newSection: ProjectSection | boolean;

    constructor(sectionData: ProjectSectionData) {
        super();

        const {
            _id,
            key,
            name,
            description,
            links = [],
            projects,
            newSection
        } = sectionData;

        // TODO: _id, key and newSection are always filled after this constructor where consumed. So this ! assertions
        // are safe. But consider a constructing the whole data here to be safer.
        this._id = _id!;
        this.key = key ?? _id!;
        this.name = name;
        this.description = description;
        this.links = links;
        this.projects = projects;
        this.newSection = newSection!;
    }
}
